var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 3.02344L12.3828 2.125L10.625 0.367188L9.72656 1.26562L6.25 4.74219L2.73438 1.26562L1.875 0.367188L0.078125 2.125L0.976562 3.02344L4.45312 6.5L0.976562 10.0156L0.078125 10.875L1.875 12.6719L2.73438 11.7734L6.25 8.29688L9.72656 11.7734L10.625 12.6719L12.3828 10.875L11.4844 10.0156L8.00781 6.5L11.4844 3.02344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.5e31c3c39c7047a2fbf8b655cbf2de84.svg";
export { ForwardRef as ReactComponent };